import styled, { css } from 'styled-components';

import { Card } from "../Card";
import { elevation } from "../Styles/Utils";

export const Box = /*#__PURE__*/styled(Card).withConfig({ displayName: "styled__Box", componentId: "sc-10y5kci-0" })(["display:flex;user-select:none;cursor:pointer;position:relative;"]);






export const Details = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Details", componentId: "sc-10y5kci-1" })(["overflow:hidden;flex:1 1 auto;padding-right:16px;display:flex;justify-content:center;flex-direction:column;"]);








export const ImageContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__ImageContainer", componentId: "sc-10y5kci-2" })(["height:96px;width:96px;flex-shrink:0;position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center;", ""],









(props) =>
props.subdued ?
css(["height:48px;width:48px;"]) :



'');


export const ImagePlaceholder = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__ImagePlaceholder", componentId: "sc-10y5kci-3" })(["height:96px;width:96px;flex-shrink:0;border-radius:4px;background-color:", ";", ""],




(props) => props.theme.colors['Level 1'],

(props) =>
props.subdued ?
css(["height:48px;width:48px;"]) :



'');


export const Title = /*#__PURE__*/styled.span.withConfig({ displayName: "styled__Title", componentId: "sc-10y5kci-4" })(["text-overflow:ellipsis;white-space:nowrap;overflow:hidden;color:", ";", " ", ""],




(props) => props.theme.colors.Foreground,
(props) => css(props.theme.typography.SmallHeadline),

(props) =>
props.subdued ?
css(["color:", ";"],
props.theme.colors['Level 4']) :

'');


export const TitleWrapper = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__TitleWrapper", componentId: "sc-10y5kci-5" })(["display:flex;margin-bottom:", ";align-items:center;"],

(props) => props.theme.spacers.S);



export const DotColor = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__DotColor", componentId: "sc-10y5kci-6" })(["width:16px;height:16px;flex:0 0 auto;border-radius:50%;box-sizing:border-box;", " ", ""],






elevation(2, false),

(props) => css(["background-color:", ";border:2px solid ", ";margin-left:", ";"],
props.dotColor,
props.theme.colors.ElementBackground,
props.theme.spacers.M));



export const RippleContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__RippleContainer", componentId: "sc-10y5kci-7" })(["border-radius:4px;width:100%;height:100%;position:absolute !important;top:0;left:0;"]);








export const SwapIconWrap = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__SwapIconWrap", componentId: "sc-10y5kci-8" })(["position:absolute;right:8px;top:8px;height:32px;width:32px;border-radius:16px;background-color:", ";display:flex;flex-direction:row;justify-content:center;align-items:center;z-index:10;"],






(props) => props.theme.colors.secondaryBackground);